const countryCodes: Record<string, string> = {
  argentina: "AR", uruguay: "UY", brasil: "BR", brazil: "BR", chile: "CL", paraguay: "PY", bolivia: "BO", peru: "PE", perú: "PE", colombia: "CO", venezuela: "VE", ecuador: "EC",
  mexico: "MX", méxico: "MX", panama: "PA", panamá: "PA", costarica: "CR", "costa rica": "CR", cuba: "CU", "republica dominicana": "DO", "república dominicana": "DO",
  espana: "ES", españa: "ES", portugal: "PT", francia: "FR", france: "FR", italia: "IT", germany: "DE", alemania: "DE", "reino unido": "GB", uk: "GB", "estados unidos": "US", usa: "US", canada: "CA", canadá: "CA",
};


export function countryFlag(country?: string) {
  if (!country) return "🌐";
  const normalized = country.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const code = countryCodes[normalized] || (/^[a-z]{2}$/i.test(country.trim()) ? country.trim().toUpperCase() : "");
  return code ? String.fromCodePoint(...[...code].map((letter) => 127397 + letter.charCodeAt(0))) : "🌐";
}
